import { Component, ChangeDetectionStrategy, ViewChild, ElementRef, ChangeDetectorRef, HostListener, ViewEncapsulation } from "@angular/core";
import { IrbRebalanceEditor } from '@irb/irb-editors/irb-editors.rebalance.base';
import {IEvent, IrbAppEvents, IrbEditorsEvents, IrbSettingsEvents} from "@irb/irb-common/events";
import { RebalanceService } from "../rebalance/rebalance.service";
import { IAnalysisPackage, ISaveRebalanceResponse, ISchedulerDTO, ISaveRebalanceAsync } from "../rebalance/irb-rebalance.model";
import { Observable, of } from "rxjs";
import { IAlertDialogData } from "@irb/app.model";
import { ISmartFilterDto } from "../irb-editors.model";
import { RebalanceIncludedPortfolioComponent } from '../rebalance/rebalance-included-portfolio/rebalance-included-portfolio.component';
import { AnalyticsService } from "@irb-common/analytics/analytics.service";
import {EditorModelService} from "@irb/irb-editors/editor-model/editor-model.service";

@Component({ standalone: false,
    selector: "irb-editor-harvest-tax-loss-rebalance",
    templateUrl: "./editor-harvest-tax-loss-rebalance.component.html",
    styleUrls: [
        "./editor-harvest-tax-loss-rebalance.component.scss", 
        "../../irb-common/styles/dialog.scss", 
        "../editor-sidebar/editor-sidebar.component.scss"
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    encapsulation: ViewEncapsulation.None
})
export class EditorHarvestTaxLossRebalanceComponent extends IrbRebalanceEditor {
  @ViewChild("body") body: ElementRef;
  @ViewChild("includedportfolio") includedportfolio: RebalanceIncludedPortfolioComponent;

  RebalanceResultId: string;
  summarySource:string;
  rebalanceTitle: string;
  defaultExpandedPanels: Array<string> = ["tlh-included-portfilio","tlh-scheduler"];

  saveLabel: string = "Process";
  isReadOnly: boolean = false;
  analysisName: string = "Harvest - ";
  analysisType: string = "Tax Loss Harvest";
  isUnitTest: boolean = false;
  isTlhWsaEnabled: boolean;
  isApplyGlobalTLH = false;
  globalSettings: any;

  constructor(private cdr: ChangeDetectorRef,
              private editorModelService: EditorModelService,
      private readonly rebalanceService: RebalanceService,
      public ats: AnalyticsService) {
    super();
    this.identifier = "analysisId";
    const config = this.as.getItem('IRB_APP_CONFIG');
    if (config)
      this.isTlhWsaEnabled = config.isTlhWsaEnabled;

    this.globalSettings = this.editorModelService.getGlobalSettings();
    if (this.globalSettings && this.isTlhWsaEnabled) {
      this.isApplyGlobalTLH = this.globalSettings.isTlhLotLevel || this.globalSettings.isTlhPositionLevel;
    }
  }

  getDefaultExpandedPanels() {
      if(this.summarySource === 'resultSummary') {
          this.defaultExpandedPanels = ["tlh-Setting"];
      }else {
          this.defaultExpandedPanels = ["tlh-Setting","tlh-included-portfilio","tlh-scheduler"];
          // QC 168261
          // let source = this.rebalanceService.getRebalanceSource();
          // if(source!==undefined && source !== null && source !=='' && source.length > 0) {
          //     this.defaultExpandedPanels = ["tlh-Setting","tlh-scheduler"];
          // }
      }
      return this.defaultExpandedPanels;
  }

  get(event: IEvent) {
    super.get(event);
    let eventData: IAnalysisPackage;
    let todayDate = this.datePipe.transform(new Date(), "MM/dd/yyyy");
    if (event.data) {
      this.rebalanceService.setRebalanceSource(event.data.source || null);
    }
    if (event.data && event.data.navigationSource === "schedulePage") {
      
      this.ignoreUnsavedChanges = true;
      this.saveLabel = "Schedule";
      this.rebalanceTitle = "Create Tax Loss Harvest";
      this.isReadOnly = false;
      eventData = {
        versionId: 0,
        analysisType: this.analysisType,
        isNew: true,
        isUIdeleted: false,
        schedulerFrequency: "None",
        navigationSource: event.data.navigationSource,
        smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto : {
          analysisType: this.analysisType,
          isCategoryAll: false,
          isCategoryBlank: false,
          isModelAll: false,
          isModelBlank: false,
          modelUpdated: false,
          sfCategoryDtoList: null,
          sfModelDtoList: null,
          smartFilterDays: null,
          analysisPortDtoList: []
        } as ISmartFilterDto,
        scheduler: {
          isActive: true,
          scheduleType: "Recurring"
        } as ISchedulerDTO,
        harvestTaxLossDto: {
          isLotLevel: true,
          isApplyGlobalTLH: this.isApplyGlobalTLH
        }
      } as IAnalysisPackage;
      
      this.applyRebalanceData(event, eventData, todayDate);
    } else {
      if (event.data !== null && event.data !== undefined && event.data.analysisId !== null && event.data.analysisId !== undefined) {
        eventData = event.data;
        this.summarySource = event.data.source;
        if (this.summarySource === 'resultSummary' || this.summarySource === 'portfolioResultDetail') {
          this.rebalanceTitle = "View Tax Loss Harvest";
          this.rebalanceService.getHistoryDetail(event.data.analysisId).subscribe((data: any) => {
            eventData = data.responseData;
            eventData.isSysSuggestion = false;
            this.load(eventData);
            this.cdr.detectChanges();
            setTimeout(() => this.onResize());
          });
        }
        if (this.summarySource === 'Scheduled' || this.summarySource === 'portfolios') {
          this.ats.trackScheduledRebalancesEditEvent();
          this.saveLabel = "Schedule";
          this.isReadOnly = false;
          this.rebalanceTitle = "Edit Tax Loss Harvest";
          this.rebalanceService.getRebalanceDetail(event.data.analysisId).subscribe((data: any) => {
            eventData = data.responseData;
            if (!eventData.tradeExpln) {
              eventData.tradeExpln = '';
            }
            if (eventData && eventData.harvestTaxLossDto) {
              eventData.harvestTaxLossDto.isApplyGlobalTLH = eventData.harvestTaxLossDto.isApplyGlobalTLH || false;
            }
            this.load(eventData);
            this.cdr.detectChanges();
            setTimeout(() => this.onResize());
          });
        }
      } else {        
        this.ignoreUnsavedChanges = true;
        this.rebalanceTitle = "Create Tax Loss Harvest";
        this.isReadOnly = false;
        eventData = {
          versionId: 0,
          analysisType: this.analysisType,
          isNew: true,
          isUIdeleted: false,
          schedulerFrequency: "None",
          tradeExpln: "",
          isSysSuggestion: true,
          isUIAllPort: false,
          analysisName: this.analysisName + todayDate,
          smartFilterDto: (event.data && event.data.smartFilterDto) ? event.data.smartFilterDto: {
            analysisType: this.analysisType,
            isCategoryAll: false,
            isCategoryBlank: false,
            isModelAll: false,
            isModelBlank: false,
            modelUpdated: false,
            sfCategoryDtoList: null,
            sfModelDtoList: null,
            smartFilterDays: null,
            analysisPortDtoList: []
          } as ISmartFilterDto,
          scheduler: {
            isActive: false,
            scheduleType: "Adhoc"
          } as ISchedulerDTO,
          harvestTaxLossDto: {
            isLotLevel: true,
            isApplyGlobalTLH: this.isApplyGlobalTLH,
            htlSecsdtoList: []
          }
        } as IAnalysisPackage;

        if (event.data && event.data.modelId) {
          eventData.modelId = event.data.modelId;
          eventData.modelName = event.data.modelName;
        }
        
        this.applyRebalanceData(event, eventData, todayDate);
      }

      if (this.summarySource !== null && this.summarySource !== undefined && this.summarySource === "resultSummary") {
        this.isReadOnly = true;
        this.ignoreUnsavedChanges = true;
      }

      if(event.data.source !== null && event.data.source !== undefined && event.data.source === "rebalancePortfolioDialog"){
          if(this.data.smartFilterDto.analysisPortDtoList !==null && this.data.smartFilterDto.analysisPortDtoList !==undefined){
              this.isReadOnly = false;
              this.isModified = true;
              this.originalData.summarySource = "rebalancePortfolioDialog";
              this.data.tradeExpln = undefined;
              this.cdr.detectChanges();
          }
      }
    }

    this.defaultExpandedPanels = this.getDefaultExpandedPanels();
      this.ies.loadExpansionState(this.defaultExpandedPanels.length, "editor-harvest-tax-loss-rebalance", this.defaultExpandedPanels, false);
      this.cdr.detectChanges();
      setTimeout(() => this.onResize());
  }

  validateInput(): Observable<string[]> {
      let errors: string[] = [];
      errors = errors.concat(this.validateDataInput());

      if (!this.isTlhWsaEnabled)
        this.data.harvestTaxLossDto.isApplyGlobalTLH = false;
      if(!this.data.harvestTaxLossDto.isApplyGlobalTLH) {
        if (!this.data.harvestTaxLossDto.htlSecsdtoList || ( this.data.harvestTaxLossDto.htlSecsdtoList && this.data.harvestTaxLossDto.htlSecsdtoList.length === 0)) {
          errors.push('This rebalance cannot be submitted because it does not contain securities to harvest.');
        }
      }
    
      return of(errors);
    }
    
  saveRebalance() {
    this.as.fireEvent(IrbEditorsEvents.SAVE_START, { "slot": this.slot });
    const includePortfolioList = this.includedportfolio.getRowData();
    this.data.smartFilterDto.analysisPortDtoList = includePortfolioList;
    this.data.smartFilterDto.analysisPortDtoListCount = includePortfolioList.length;
    this.validateInput().subscribe(errors => {      
      if (errors.length > 0) {
        let errMsg: string = errors.join("\n");

        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Alert",
            msg: errMsg,
            dProceedBtnLabel: "Ok",
            dType: "ERROR"
        } as IAlertDialogData);
        
        this.as.fireEvent(IrbEditorsEvents.HIDE_WAIT, { "slot": this.slot });
      } else {
        
        if(this.data.schedulerFrequency === "Daily"){
          this.data.schedulerFrequency = this.data.scheduler.reccuringFreqType;
        }
        delete this.data.navigationSource;
        this.trackEditEvent(this.data);
        let a = this.data.smartFilterDto.analysisPortDtoList.length >= this.portfolioThreshold;
        let b = this.data.harvestTaxLossDto.htlSecsdtoList?.length >= this.securityThreshold;

        if (!this.isTlhWsaEnabled) {
          this.data.harvestTaxLossDto.isApplyGlobalTLH = false;
          this.data.harvestTaxLossDto.htlSecsdtoList?.forEach((sec: any) => {
            if (sec.replaceSecId) {
              sec.primarySecSymb = null;
              sec.primarySecId = null;
              sec.primarySecType = null;
              sec.secondarySecSymb = null;
              sec.secondarySecId = null;
              sec.secondarySecType = null;
            }
          });
        } else {
          this.data.harvestTaxLossDto.htlSecsdtoList?.forEach((sec: any) => {
            // make sure that save '$CASH' and not '$CASH (Leave in Cash)'
            if (sec.primarySecSymb && sec.primarySecSymb.indexOf('$CASH') !== -1)
              sec.primarySecSymb = '$CASH';
            if (sec.secondarySecSymb && sec.secondarySecSymb.indexOf('$CASH') !== -1)
              sec.secondarySecSymb = '$CASH';
            if (sec.secondarySecId === -1) {
              sec.secondarySecSymb = null;
              sec.secondarySecId = null;
              sec.secondarySecType = null;
            }
            sec.replaceSecSymb = null;
            sec.replaceSecId = null;
            sec.replaceSecType = null;
          });
          if (this.data.harvestTaxLossDto.isApplyGlobalTLH && this.globalSettings && this.data.isNew) {
            this.data.harvestTaxLossDto.isLotLevel = this.globalSettings.isTlhLotLevel ? true : false;
          }
        }

        if(a || b) {
          this.crbservice.saveRebalanceAsync(this.data).subscribe((data: ISaveRebalanceAsync) => {
            this.checkSaveRebalanceAsyncStatus(data.rprasId);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
          });
        } else {
          this.crbservice.saveRebalance(this.data).subscribe((data: ISaveRebalanceResponse) => {
            this.completeSaveRebalance(data);
          }, () => {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
              this.setGlobalError();
          });
        }
      }
    });
  }

  completeSaveRebalance(response: ISaveRebalanceResponse) {
          if (response.responseStatus === "SUCCESS") {
            if (response.responseUtilityMap != null) {
              let analysisId = String(response.responseUtilityMap.analysisId);
              let rebalanceResultId = String(response.responseUtilityMap.rebalanceResultId);
              let rebalanceName = response.responseUtilityMap.rebalanceName;

              let submitTiQueueReq: any = {Package: analysisId, RebalanceResult: rebalanceResultId};

              let saveSuccessEventData: {};
              let hasPendFunc: boolean = this.hasPendingFunction;
              if (!hasPendFunc) {
                saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "slot": this.slot };
                if (this.data.schedulerFrequency === "None") {
                  this.submitPackageToQueue(submitTiQueueReq, rebalanceName, rebalanceResultId, hasPendFunc,saveSuccessEventData);
                } else {
                  this.navigateToScheduledRebalances();
                }
              } else {
                saveSuccessEventData = { "hasPendingFunction": hasPendFunc, "data": rebalanceName+" Rebalance Submitted", "slot": this.slot };
                if (this.data.schedulerFrequency === "None") {
                  this.submitPackageToQueue(submitTiQueueReq, rebalanceName, rebalanceResultId, hasPendFunc,saveSuccessEventData);
                }
              }
              
            }
              this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
          } else {
            this.as.fireEvent(IrbEditorsEvents.SAVE_ERROR, { "slot": this.slot });
            this.setGlobalError();
          }
  }

  submitPackageToQueue(submitTiQueueReq: any, rebalanceName: string, rebalanceResultId: any, hasPendFunc: boolean,saveSuccessEventData:any) {
    this.rebalanceService.submitPortfoliosToQueue(submitTiQueueReq).subscribe(() => {
      if (!hasPendFunc) {
        this.alertUserOnSubmissionOrSave(rebalanceName, rebalanceResultId,saveSuccessEventData);
      } else {
        setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS, saveSuccessEventData); });
      }      
    });
  }

  alertUserOnSubmissionOrSave(rebalanceName: string, rebalanceResultId: any,saveSuccessEventData:any) {
    this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
      dTitle: "Rebalance Submitted",
      msg: rebalanceName,
      altMsg: "Go to rebalance results summary to check the status of this submission.",
      dProceedBtnLabel: "Go to Rebalance Result Summary",
      dType: "WARN",
      onProceed: (() => {
          this.navigateToResultSummary(rebalanceResultId);
          this.closeWithoutSave();
      }).bind(this),
      onCancel: (() => {
          this.closeWithoutSave();
      }).bind(this)
    } as IAlertDialogData);
    
    setTimeout(() => { this.as.fireEvent(IrbEditorsEvents.SAVE_SUCCESS,saveSuccessEventData); });    
  }

  @HostListener("window:resize")
  onResize() {
      if (this.body) {
          const rect = this.body.nativeElement.getBoundingClientRect();
          let h = (window.innerHeight - rect.top - 10);

          h = (h < 200) ? 200 : h;
          this.bodyHeight = h + "px";
      }
  }

  close() {
    super.close();
    
      if(this.isModified) {
          this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
      }
  }

  getPortfolioCount() {
      if(this.data && this.data.isUIAllPort && this.data.isUIAllPort === true) {
          return "All portfolios included";
      }
      if(this.data?.smartFilterDto?.analysisPortDtoList !==null
          && this.data?.smartFilterDto?.analysisPortDtoList !==undefined
          && this.data?.smartFilterDto?.analysisPortDtoList?.length) {
          if(this.data?.smartFilterDto?.analysisPortDtoList?.length > 1) {
              return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolios included";
          } else if (this.data?.smartFilterDto?.analysisPortDtoList?.length === 1) {
              return this.data?.smartFilterDto?.analysisPortDtoList?.length + " portfolio included";
          } else {
              return 0 + " portfolios included";
          }
      } else {
          return 0 + " portfolios included";
      }
  }

  closeAndNavigate(url: string) {
    this.router.navigate([url]);
    this.closeWithoutSave();
  }
}
